export default __webpack_public_path__ + "static/DidotLTStd-Regular-220287b7096a2f7008e0f2bba0a3e780.woff2";